import React from 'react';

import { DropOverContainer } from '@/components/DragDrop';
import useDraggableItem from '@/modules/corporate/components/DraggableList/hooks/useDraggableItem';
import { DraggableListItemProps } from '@/modules/corporate/components/DraggableList/types';

function DraggableListItem(props: DraggableListItemProps) {
  const { className, index, disabled, draggingItemRef, onDrop, renderItem } = props;
  const { getDragHandleProps, getDropOverContainerProps } = useDraggableItem({
    key: index,
    disabled,
    draggingItemRef,
    onDrop,
  });

  const memoizedRenderItem = React.useMemo(
    () => renderItem(index, getDragHandleProps),
    [getDragHandleProps, index, renderItem],
  );

  return (
    <DropOverContainer className={className} {...getDropOverContainerProps()}>
      {memoizedRenderItem}
    </DropOverContainer>
  );
}

export default React.memo(DraggableListItem);
